var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkiJump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.7,54H66.9v18h34.7c1.2,0,2.3-0.2,3.4-0.7c1.1-0.4,2.1-1.1,3-2c0.9-0.9,1.5-1.9,2-3c0.4-1.1,0.7-2.2,0.7-3.4 c0-1.2-0.2-2.3-0.7-3.4c-0.4-1.1-1.1-2.1-2-3L72.7,21.3c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3L90.7,54z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.1,
    cy: 55.3,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,113.2c1.3,0,2.6-0.5,3.6-1.5l43.1-43.1V54l-50.4,50.4c-1,1-1.5,2.3-1.5,3.6s0.5,2.6,1.5,3.6 C12.3,112.7,13.6,113.2,14.9,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,87.4c0,1.3-0.4,2.6-1,3.8c-1,1.8-2.7,3-4.6,3.6L0,123.5v2.8l108.1-29c2.7-0.7,4.9-2.4,6.3-4.8 c0.9-1.6,1.4-3.3,1.4-5.1L113.1,87.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiJump);
export default __webpack_public_path__ + "static/media/skiJump.24b9d8afe6bb2cd2ca09555aff8e48c6.svg";
export { ForwardRef as ReactComponent };